<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row
        v-if="adminProcess === false"
      >
        <!-- old password -->
        <b-col md="6">
          <b-form-group
            label="Masukan Password Lama"
            label-for="account-old-password"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-old-password"
                v-model="passwordValueOld"
                name="old-password"
                :type="passwordFieldTypeOld"
                placeholder="Masukan Password Lama"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconOld"
                  class="cursor-pointer"
                  @click="togglePasswordOld"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--/ old password -->
      </b-row>
      <b-row>
        <!-- new password -->
        <b-col md="6">
          <b-form-group
            label-for="account-new-password"
            label="Masukan Password Baru"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-new-password"
                v-model="newPasswordValue"
                :type="passwordFieldTypeNew"
                name="new-password"
                placeholder="Masukan Password Baru"
                v-on:keyup="validatePassword"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconNew"
                  class="cursor-pointer"
                  @click="togglePasswordNew"
                />
              </b-input-group-append>
            </b-input-group>
            <!-- <pre v-if='password'>Password Length {{password.length}}</pre> -->
            <p v-if="errors_password.length" style="color:red">{{ errors_password[0] }}</p>
          </b-form-group>
        </b-col>
        <!--/ new password -->

        <!-- retype password -->
        <b-col md="6">
          <b-form-group
            label-for="account-retype-new-password"
            label="Konfirmasi Password Baru"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-retype-new-password"
                v-model="RetypePassword"
                :type="passwordFieldTypeRetype"
                name="retype-password"
                placeholder="Konfirmasi Password Baru"
                v-on:keyup="validatePasswordConfirm"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconRetype"
                  class="cursor-pointer"
                  @click="togglePasswordRetype"
                />
              </b-input-group-append>
            </b-input-group>
            <!-- <pre v-if='password'>Password Length {{password.length}}</pre> -->
            <p v-if="errors_password_confirm.length" style="color:red">{{ errors_password_confirm[0] }}</p>
          </b-form-group>
        </b-col>
        <!--/ retype password -->

        <!-- buttons -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            @click="simpan"
          >
            Simpan
          </b-button>
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            class="mt-1"
          >
            Reset
          </b-button> -->
        </b-col>
        <!--/ buttons -->
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import {
  changePassword,
} from '@/api/user'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  props: {
    adminProcess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      errors_password: [],
      validate_toast_errors_password: 0,
      RetypePassword: '',
      errors_password_confirm: [],
      validate_toast_errors_password_confirm: 0,
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      localData: {
        RetypePassword: '',
        newPasswordValue: '',
        passwordValueOld: '',
        userId: 0,
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    validatePassword() {
      // console.log(this.password)
      this.errors_password = []
      if (!this.newPasswordValue) {
        this.errors_password.push('New Password is required')
        this.validate_toast_errors_password = 1
      } else if (this.newPasswordValue.length < 8) {
        this.errors_password.push('New Password must be at least 8 characters long')
        this.validate_toast_errors_password = 1
      } else if (!/\d/.test(this.newPasswordValue)) {
        this.errors_password.push('New Password must contain at least one number')
        this.validate_toast_errors_password = 1
      } else if (!/[a-z]/.test(this.newPasswordValue)) {
        this.errors_password.push('New Password must contain at least one lowercase letter')
        this.validate_toast_errors_password = 1
      } else if (!/[A-Z]/.test(this.newPasswordValue)) {
        this.errors_password.push('New Password must contain at least one uppercase letter')
        this.validate_toast_errors_password = 1
      // } else if (!/[!@#$%^&*()_+\-.{}[\]~]/.test(this.password)) {
      } else if (!/[!@#$%^&*]/.test(this.newPasswordValue)) {
        // this.errors_password.push('Password must contain at least one symbol (!@#$%^&*()_+-.[]~)')
        this.errors_password.push('Password must contain at least one symbol (!@#$%^&*)')
        this.validate_toast_errors_password = 1
      } else {
        this.validate_toast_errors_password = 0
      }

      // console.log(this.errors_password[0])
    },
    validatePasswordConfirm() {
      // console.log(this.password)
      this.errors_password_confirm = []
      if (!this.RetypePassword) {
        this.errors_password_confirm.push('Confirm New Password is required')
        this.validate_toast_errors_password_confirm = 1
      } else if (this.newPasswordValue.length < 8) {
        this.errors_password_confirm.push('Confirm New Password must be at least 8 characters long')
        this.validate_toast_errors_password_confirm = 1
      } else if (!/\d/.test(this.RetypePassword)) {
        this.errors_password_confirm.push('Confirm New Password must contain at least one number')
        this.validate_toast_errors_password_confirm = 1
      } else if (!/[a-z]/.test(this.RetypePassword)) {
        this.errors_password_confirm.push('Confirm New Password must contain at least one lowercase letter')
        this.validate_toast_errors_password_confirm = 1
      } else if (!/[A-Z]/.test(this.RetypePassword)) {
        this.errors_password_confirm.push('Confirm New Password must contain at least one uppercase letter')
        this.validate_toast_errors_password_confirm = 1
      // } else if (!/[!@#$%^&*()_+\-.{}[\]~]/.test(this.password)) {
      } else if (!/[!@#$%^&*]/.test(this.RetypePassword)) {
        // this.errors_password.push('Password must contain at least one symbol (!@#$%^&*()_+-.[]~)')
        this.errors_password_confirm.push('Password must contain at least one symbol (!@#$%^&*)')
        this.validate_toast_errors_password_confirm = 1
      } else {
        this.validate_toast_errors_password_confirm = 0
      }

      // console.log(this.errors_password_confirm[0])
    },
    async simpan() {
      if (this.$route.params.id) {
        this.localData.userId = this.$route.params.id
      } else {
        this.localData.userId = this.userData.id
      }

      if (this.validate_toast_errors_password === 1) {
        this.makeToast('danger', this.errors_password[0])
        this.show = false
      } else if (this.validate_toast_errors_password_confirm === 1) {
        this.makeToast('danger', this.errors_password_confirm[0])
        this.show = false
      } else {
        this.localData.RetypePassword = this.RetypePassword
        this.localData.newPasswordValue = this.newPasswordValue
        this.localData.passwordValueOld = this.passwordValueOld
        this.localData.adminProcess = this.adminProcess

        const response = await changePassword(this.localData)
        if (response.data.status.code === '00') {
          this.makeToast('success', 'Ubah Informasi Berhasil!')
        } else {
          this.makeToast('danger', response.data.data)
          this.show = false
        }
      }
    },
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Ubah Kata Sandi',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  },
}
</script>
